export const CATEGORIES = [
  { id: "all", label: "All", short: "Everything" },
  { id: "ai-prompts", label: "AI Prompts", short: "Prompts" },
  { id: "ebooks", label: "Ebooks & Cookbooks", short: "Ebooks" },
  { id: "remedies", label: "Remedies", short: "Remedies" },
  { id: "beauty", label: "Beauty Products", short: "Beauty" },
  { id: "jewelry", label: "Jewelry", short: "Jewelry" },
  { id: "merch", label: "This That Merch", short: "Merch" },
  { id: "home-goods", label: "Home Goods", short: "Home" },
  { id: "tinytunes", label: "Tiny Tunes Dancer", short: "TinyTunes" },
  { id: "media", label: "Videos & Podcasts", short: "Media" },
  { id: "affiliate", label: "Affiliate Picks", short: "Affiliate" },
];

export function categoryLabel(id) {
  return CATEGORIES.find((c) => c.id === id)?.label || id;
}
